import { Button } from "antd";

export default function Ready() {
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #2098EE1A", backgroundColor: "#D3E8FC4D" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/ready.svg" alt="" />
        <Button
          htmlType="button"
          className="light-blue-btn btn-sm"
          type="primary"
        >
          Send to customer
        </Button>
      </div>
      <h5> Proposal ready </h5>
      <h6> It can be sent to the customer. </h6>
    </div>
  );
}
